import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on every route change, unless navigating to a hash anchor
 * or via state.scrollTo (handled by HomePage).
 */
export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();
  useEffect(() => {
    if (hash) return;
    if (state?.scrollTo) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash, state]);
  return null;
}
